import { Box, CircularProgress, LinearProgress } from "@mui/material";
import React, { useEffect } from "react";
import { useManagementUnitCaptures } from "../../../hooks/ManagementUnit/useManagementUnitCaptures";
import CaptureView from "../../Captures/CaptureView";

interface CapturesTabProps {
  managementUnitId?: string;
  entityId?: number;
  handleError?: any;
}

const CapturesTab: React.FC<CapturesTabProps> = ({ managementUnitId, entityId, handleError }) => {
  const {
    page,
    rowsPerPage,
    setPage,
    setRowsPerPage,
    setFilters,
    capturesQuery,
    mapQuery,
  } = useManagementUnitCaptures(managementUnitId, entityId);

  const captures = capturesQuery.data?.data ?? [];
  const total = capturesQuery.data?.total ?? 0;
  const geojson = mapQuery.data;

  useEffect(() => {
    if (!handleError) return;

    if (capturesQuery.isError) {
      handleError(capturesQuery.error);
      return;
    }

    if (mapQuery.isError) {
      handleError(mapQuery.error);
    }
  }, [capturesQuery.isError, mapQuery.isError, capturesQuery.error, mapQuery.error, handleError]);

  const isInitialLoading = (capturesQuery.isPending && !capturesQuery.data) || (mapQuery.isPending && !mapQuery.data);

  if (isInitialLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  const isBackgroundFetching = (capturesQuery.isFetching && !capturesQuery.isPending) || (mapQuery.isFetching && !mapQuery.isPending);

  return (
    <Box sx={{ position: "relative" }}>
      {isBackgroundFetching && (
        <LinearProgress
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 10,
            height: 2,
          }}
        />
      )}

      <CaptureView
        tableData={captures}
        onRequestRefresh={() => capturesQuery.refetch()}
        onApplyFilters={setFilters}
        geojson={geojson}
        entityId={entityId}
        managementUnitId={managementUnitId ? Number(managementUnitId) : undefined}
        mapHasData={(geojson?.features?.length ?? 0) > 0}
        page={page}
        rowsPerPage={rowsPerPage}
        totalCapturesCount={total}
        onPageChange={(_e, newPage) => setPage(newPage)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(Number(e.target.value));
          setPage(0);
        }}
        isLoading={false}
      />
    </Box>
  );
};

export default CapturesTab;
